// extracted by mini-css-extract-plugin
export default {"root":"CpHaI2dOGA","root_disabled":"E27JCxTyrj","icon_nonColorizable":"k6J_PONH1Z","root_height1":"lZRgWO2wF6","icon":"KKYTdHXdBb","footer":"F1PMyi2iN0","name":"L6htSmJ36S"};